import Vue from 'vue'
import VuePusher from 'vue-pusher'

Vue.use(VuePusher, {
  api_key: process.env.VUE_APP_PUSHER_API_KEY,
  options: {
    cluster: 'mt1',
    encrypted: true,
    authEndpoint: `${process.env.VUE_APP_API_URL}pusher-auth/channel-auth`,
    auth: {
      headers: {
        'X-Pusher-DD-Auth': 'will-be-replaced-at-call-time', // Need to stub out here or else its undefined
      },
    },
  },
})

declare module 'vue/types/vue' {
  export interface Vue {
    $pusher: any
  }
}
